export const shippingCarriers = [
    {
        id: 'ups',
        name: 'UPS',
        trackingUrlTemplate: 'https://www.ups.com/track?loc=en_US&tracknum={trackingNumber}',
    },
    {
        id: 'fedex',
        name: 'FedEx',
        trackingUrlTemplate: 'https://www.fedex.com/fedextrack/?trknbr={trackingNumber}',
    },
    {
        id: 'usps',
        name: 'USPS',
        trackingUrlTemplate: 'https://tools.usps.com/go/TrackConfirmAction?tLabels={trackingNumber}',
    },
    {
        id: 'dhl',
        name: 'DHL',
        trackingUrlTemplate: 'https://www.dhl.com/global-en/home/tracking.html?tracking-id={trackingNumber}',
    },
    {
        id: 'other',
        name: 'Other',
        trackingUrlTemplate: undefined,
    },
] as const;

